import { Container, Divider, Group, rem, Title, useMantineTheme } from '@mantine/core';
import type { PropsWithChildren } from 'react';

import { GoBackButton } from '../back-button';

type Props = PropsWithChildren<{
	title: string;
	fluid?: boolean;
}>;

export function DetailsLayout({ title, fluid, children }: Props) {
	const theme = useMantineTheme();

	return (
		<Container
			size='xl'
			pt='xs'
			mt={rem(theme.other.headerHeight)}
			h={`calc(100% - ${theme.other.headerHeight})`}
			fluid={fluid}
		>
			<Group justify='flex-start' mb='xs'>
				<GoBackButton variant='icon' />
				<Title order={4}>{title}</Title>
			</Group>
			<Divider size='sm' mb='lg' />
			{children}
		</Container>
	);
}
